import React, { Component } from "react";
import { Button, Tooltip, message } from "antd";
import AudioTag from "../../Common/AudioTag";
import { ReactComponent as CopyIcon } from "../../../../assets/images/icons/copy-icon1.svg"; 
import { ReactComponent as EyeIcon } from "../../../../assets/images/icons/eyeNew.svg"; 

import "./index.scss";
import NdrImagemodal from "./MediaModal/index";

class CallSummary extends Component {
  state = {
    showMediaModal: false,
  };

  formatConversation = (audio_result) => {
    if (!audio_result) return "";
    return audio_result
      .map((line) => {
        const speaker = line.by === "speaker_0" ? "Speaker 1" : "Speaker 2";
        return `${speaker}: ${line.text}`;
      })
      .join("\n");
  };

  handleCopy = () => {
    const formatted = this.formatConversation(this.props.ndrAiData.audio_result);
    navigator.clipboard.writeText(formatted).then(() => {
      message.success("Conversation copied!");
      setTimeout(() => {
        message.destroy();
      }, 1000);
    });
  };

  checkAudio = () => {
    const { dispute } = this.props;
    const image = dispute.files ? dispute.files.filter((file) => file.filetype === "image") : [];
    const video = dispute.files ? dispute.files.filter((file) => file.filetype === "video") : [];
    const audio = dispute.files ? dispute.files.filter((file) => file.filetype === "audio") : [];

    if (!image.length && !video.length && !!audio.length && audio.length === 1) {
      let audioFile = audio[0].file;
      return <AudioTag src={audioFile} />;
    } else {
      return (
        <Button
          className="clickable"
          onClick={() => this.setState({ showMediaModal: true })}
        >
          View Media
        </Button>
      );
    }
  };

  render() {
    const { ndrAiData } = this.props;

    return (
      <div className="escalation-media-container">
        <div>
            {this.checkAudio()}

        {ndrAiData.audio_result && !!ndrAiData.audio_result.length ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent:"center",
              marginTop: 8,
              gap: 8,
            }}
          >
            <Tooltip
              placement="left"
              overlayClassName="audio-chat-tooltip"
              title={
                <div className="conversation-container">
                  {ndrAiData.audio_result.map((line, index) => {
                    const alignmentClass = line.by === "speaker_0" ? "left" : "right";
                    const speaker = line.by === "speaker_0" ? "Speaker 1" : "Speaker 2";

                    return (
                      <div key={index} className={`message-block ${alignmentClass}`}>
                        <div className="speaker-label">{speaker}</div>
                        <div className={`chat-bubble ${alignmentClass}`}>
                          {line.text}
                        </div>
                      </div>
                    );
                  })}
                </div>
              }
            >
              <div style={{ color: "#1370fb" }}>Transcription <span style={{
                position: "relative",
                top: "6px",
              }}><EyeIcon/></span> </div>
            </Tooltip>
            <Tooltip title="Copy Conversation">
              <p style={{ cursor: "pointer" ,position:"relative", top:"6px" }} onClick={this.handleCopy}>
                <CopyIcon />
              </p>
            </Tooltip>
          </div>
        ) : null}

        <NdrImagemodal
          visible={this.state.showMediaModal}
          toggleModal={() => this.setState({ showMediaModal: false })}
          showMediaModal={{
            data: this.props.dispute.files || [],
            vfId: this.props.dispute.order_vfid,
            awb: this.props.dispute.awb
          }}
        />
        </div>
      
      </div>
    );
  }
}

export default CallSummary;